export const VIDEO_SELECT_SHOW  = 'VIDEO_SELECT_SHOW';
export const VIDEO_SELECT_HIDE  = 'VIDEO_SELECT_HIDE';
export const VIDEO_SELECT_SET_IMAGE  = 'VIDEO_SELECT_SET_IMAGE';